module.exports = __webpack_public_path__ + "img/calendar.5b1a0d73.png";